import type { IconSvgObject } from './types';

const InsertRowUpIcon: IconSvgObject = [
  ["path", { d: "M9 5.5L12 2.5L15 5.5M12 3.5V10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.5 15H21.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.5 21.5L8.5 15M15.5 21.5L15.5 15", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default InsertRowUpIcon;
